import { RegionOption } from '@app/components/Molecules/RegionFilter'
import { DrawArea, MapLayer, MapLocation } from '@app/redux/riskMap/riskMapSlice'
import { NEW_ZEALAND_LAT, NEW_ZEALAND_LGT, NEW_ZEALAND_ZOOM_LEVEL } from '@app/app-constants'
import { Map, Expression, MapboxGeoJSONFeature } from 'mapbox-gl'
import { FitBoundsOfFeatureOptions, FlyTo } from '../utils/location'
import { Dispatch, SetStateAction } from 'react'
import { RemoveLayerByIdProps } from '../utils/layers'

export interface MapProviderProps {
  children: React.ReactNode
}

export const AppInitialLocation: MapLocation = {
  latitude: NEW_ZEALAND_LAT,
  longitude: NEW_ZEALAND_LGT,
  zoom: NEW_ZEALAND_ZOOM_LEVEL,
}

export interface MapLayerStyle {
  paint: {
    [property: string]: Expression
  }
  layout: {
    [property: string]: Expression
  }
}

export interface MapLayerStyles {
  [id: string]: MapLayerStyle
}

export interface ClearMapProps {
  map: Map
}

export interface ChangeMapStyleProps {
  style: string
}
export interface FitToBoundsProps {
  boundingBox: [number, number, number, number]
  map: Map
}

export interface RemoveRegionMasksLayersProps {
  map: Map
}

export interface UpdateLayersProps {
  layers: MapLayer[]
}

export interface UpdateDrawAreasProps {
  drawAreas: DrawArea[]
}

export interface GenericMapContextInterface {
  map: Map | null
  regionMasks: RegionOption[] | null
  mapLayerStyles: MapLayerStyles
  basemap: string
  clientLocation: MapLocation
  handleSetClientLocation: (location: MapLocation) => void
  setRegionMasks: (regions: RegionOption[] | null) => void
  clearMap: (props: ClearMapProps) => void
  changeMapStyle: (props: ChangeMapStyleProps) => void
  flyTo: (props: FlyTo) => void
  flyToFeature: (feature: GeoJSON.Feature, flyToOptions?: Partial<FlyTo>) => void
  fitToBounds: (props: FitToBoundsProps) => void
  fitToBoundsOfFeature: (
    feature: MapboxGeoJSONFeature | GeoJSON.Feature,
    { usePadding }: FitBoundsOfFeatureOptions,
  ) => void
  removeLayerById: (props: RemoveLayerByIdProps) => void
  setMapInstance: (map: Map | null) => void
  updateLayers: (props: UpdateLayersProps) => void
  updateDrawAreas: (props: UpdateDrawAreasProps) => void
  setMapPadding: (padding: { top: number; right: number; bottom: number; left: number }) => void
  getMapPadding: (usePadding: boolean | undefined) => {
    top: number
    right: number
    bottom: number
    left: number
  }
  mapPaddingRef: React.MutableRefObject<{
    top: number
    right: number
    bottom: number
    left: number
  }>
  mapPaddingIsChanging: {
    top: boolean
    right: boolean
    bottom: boolean
    left: boolean
  }
  setMapPaddingIsChanging: Dispatch<
    SetStateAction<{ top: boolean; right: boolean; bottom: boolean; left: boolean }>
  >
  mapIs3D: boolean
  setMapIs3D: Dispatch<SetStateAction<boolean>>
  setBasemap: (basemap: string) => void
  setInteractive: (interactive: boolean) => void
  interactive: boolean
  setFlyToClientLocation: (flyToClientLocation: boolean) => void
  regionFilters: RegionOption[] | null
  setRegionFilters: (regions: RegionOption[] | null) => void
}
